import { useBearAuth } from '@bear-auth/react';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';

import config from '@/config';

export function useLogout() {
    const dispatch = useDispatch();
    const {
        actions: { logout },
    } = useBearAuth();

    return useMutation({
        mutationFn: async () => {
            await logout();
            dispatch(push(config.routes.home));
        },
    });
}
